import React from 'react'
import PropTypes from 'prop-types'
import mergeRanges from 'merge-ranges'
import { remove } from 'diacritics'

function allIndexesOf (string, word) {
  const indexes = []
  for (let index = string.indexOf(word); index !== -1; index = string.indexOf(word, index + 1)) {
    indexes.push(index)
  }
  return indexes
}

function combine (text, ranges) {
  if (ranges.length === 0) {
    return text
  }
  let lastStart = 0
  let parts = []

  for (let i = 0; i < ranges.length; i++) {
    let [start, end] = ranges[i]
    if (lastStart !== start) {
      parts.push(<span key={lastStart}>{text.slice(lastStart, start)}</span>)
    }
    parts.push(<strong key={start}>{text.slice(start, end)}</strong>)

    if (i === ranges.length - 1 && end !== text.length) {
      parts.push(<span key={end}>{text.slice(end)}</span>)
    }
    lastStart = end
  }
  return parts
}

const HighlightText = ({ highlight, children }) => {
  if (!highlight) {
    return <span>{children}</span>
  }
  const normalizedText = remove(children).toLowerCase()
  const highlightIntervals = highlight
    .split(/(\s+)/)
    .map(word => word.trim())
    .filter(word => word)
    .reduce((intervals, word) => {
      const normalizedWord = remove(word).toLowerCase()
      const wordIntervals = allIndexesOf(normalizedText, normalizedWord).map(index => [
        index,
        index + normalizedWord.length
      ])
      return intervals.concat(wordIntervals)
    }, [])

  return <span>{combine(children, mergeRanges(highlightIntervals))}</span>
}

HighlightText.propTypes = {
  highlight: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
}

export default HighlightText
